
import { useEffect, useState } from "react"
import { ChartstwitsRepository } from "../../repository/ChartstwitsRepository";

export function WicktockModel(){
    const apiModel = ChartstwitsRepository();
    const VideoAPIPath = apiModel.chartTwitsViewPath
    const [lstWicktok,setWicktok] = useState([{
        Wictok_ID: 0,
        User_ID: 0,
        VideoURL: "",
        CreatedDate: "",
        UpdatedDate: "",
        Liked: 0
    }])

    const getWictok = async () =>{
        debugger;
        // setWicktok([]);
        const responseData:any = await apiModel.getWictok();
        debugger;
        if (responseData.length > 0) {
            debugger;
            setWicktok(responseData);
        }
    }

    const like = async (d:any) =>{
        debugger;
        let like ;
        if(d.Liked == 0){
          like = 1
        } else{
          like = 0;
        }

        let data = JSON.stringify({'Id':d.wcktId,'WicktockId':d.Wictok_ID,'UserId':0,'Like':like,'Comment':''})
        const responseData:any = await apiModel.Wicktocklikecomment(data);
        if (responseData.length > 0) {
            debugger;
            // setWicktok(responseData);
            let newLst = [...lstWicktok];
            for(let i=0;i<newLst.length;i++){
                debugger;
                if(d.Wictok_ID == newLst[i].Wictok_ID){
                    debugger;
                    newLst[i].Liked = like;
                }
            }

            setWicktok(newLst);
        }
    }   

    useEffect(()=>{
        getWictok();
    },[])

    return{lstWicktok,VideoAPIPath,like}
}